import { cartBus } from '@/event/cartBus'
import { computed } from 'vue'

export const totalPriceBasket = computed(() => {
    let total = cartBus.value.reduce((total, item) => {
        return total + item.total_price
    }, 0)

    return Number(total).toFixed(2)
})
